export default __webpack_public_path__ + "static/media/Lily.8c478daa.png";